import React, {
  useState,
  useEffect,
  forwardRef
} from "react";
import {
  useNavigate
} from "react-router-dom";
import './Header.css';

const Header = forwardRef((props, ref) => {
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  // Initialize with saved language from localStorage or default to "English"
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return localStorage.getItem('userLanguage') || "English";
  });
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);

  // Enhanced scroll behavior with backdrop blur
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollThreshold = 50;

      // Update scrolled state for backdrop blur
      setIsScrolled(currentScrollY > scrollThreshold);

      // Hide header on fast scroll down, show on scroll up
      if (currentScrollY > prevScrollY && currentScrollY > 200) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      setPrevScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollY]);

  const handleFeedbackClick = () => {
    navigate("/feedback");
  };

  const handleLanguageChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedLanguage(selectedValue);
    localStorage.setItem('userLanguage', selectedValue); // Save to localStorage
    console.log("Selected language:", selectedValue); // Replace with actual implementation
  };

  return (
    <header 
      ref={ref} 
      className={`vitstra-header ${hidden ? "hidden" : ""} ${isScrolled ? "scrolled" : ""}`}
      role="banner"
    >
      {/* Background overlay for glass effect */}
      <div className="header-backdrop" aria-hidden="true"></div>

      <div className="header-container">
        <div className="header-brand">
          <button 
            className="logo-button"
            aria-label="VitStra - Navigate to home"
            type="button"
          >
            <div className="brand-logo">
              <span className="logo-icon" aria-hidden="true">◊</span>
              <h1 className="brand-name">
                <span>V</span><span>i</span><span>t</span>
                <span>S</span><span>t</span><span>r</span><span>a</span>
              </h1>
            </div>
          </button>
        </div>

        <nav className="header-nav" role="navigation" aria-label="Main navigation">
          <select
            className="language-selector"
            value={selectedLanguage}
            onChange={handleLanguageChange}
            aria-label="Select language"
          >
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Both">Both</option>
          </select>
          <button 
            className="nav-button feedback-button"
            onClick={handleFeedbackClick}
            type="button"
          >
            <span className="button-icon" aria-hidden="true">💭</span>
            <span className="button-text">Feedback</span>
          </button>
        </nav>
      </div>

      {/* Subtle progress indicator */}
      <div className="scroll-progress" aria-hidden="true"></div>
    </header>
  );
});

Header.displayName = 'VitStraHeader';

export default Header;